import { convert } from 'colvertize'; // https://github.com/Philipp-M/colvertize
export function setOpacity(opacity, color) {
    if (!opacity || !color) {
        return color;
    }
    var rgbaParse = function (c) {
        return {
            r: c.r,
            g: c.g,
            b: c.b,
            a: opacity,
        };
    };
    return convert(color, 'css-hex', rgbaParse);
}
export function getOpacityFromColor(color) {
    var rgbaParse = function (c) {
        return {
            r: c.r,
            g: c.g,
            b: c.b,
            a: c.a,
        };
    };
    return rgbaParse(convert(color, 'rgb')).a || 1;
}
//# sourceMappingURL=colorUtils.js.map